import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  modal: {
    maxWidth: 580
  },
  mainLabel: {
    marginBottom: theme.spacing(4)
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: theme.spacing(2),
    marginTop: theme.spacing(6)
  },
  buttons: {
    padding: theme.spacing(0, 6)
  },
  // #33937: helper lines under the street-address field. Negative top margin tucks them beneath the
  // field within the container's gap; the locked line is muted, the approval note uses the CTA color.
  lockedAddress: {
    marginTop: theme.spacing(-2),
    color: theme.colors.form_label_primary
  },
  approvalNote: {
    marginTop: theme.spacing(-2),
    color: theme.colors.info__label_text
  }
});

export default makeStyles(styles);
